import React from 'react';

const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/919906067123"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: '30px',
        right: '30px',
        width: '55px',
        height: '55px',
        background: '#25D366',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: '1.8rem',
        cursor: 'pointer',
        boxShadow: '0 4px 15px rgba(37, 211, 102, 0.4)',
        transition: 'all 0.3s ease',
        zIndex: 1000
      }}
    >
      <i className="fab fa-whatsapp"></i>
    </a>
  );
};

export default WhatsAppFloat;